import { useAnalyticsPublisher as useAnalyticsPublisherCore } from '@front/model'

function getSessionId(): string {
  const key = 'terros-session-id'
  let sessionId = sessionStorage.getItem(key)
  if (!sessionId) {
    sessionId = `web-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
    sessionStorage.setItem(key, sessionId)
  }
  return sessionId
}

export function useAnalyticsPublisher(): void {
  useAnalyticsPublisherCore({
    sessionId: getSessionId(),
    isDev: import.meta.env.DEV,
  })
}
